import { gql } from '@apollo/client';

export const CompanyQuery = gql`
  query Company($companyId: Int!) {
    company(id: $companyId) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
